import {
    Alert,
    Button,
    Container,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AccountService, UserDto } from "../../api/identity";
import { PageHeader, PrivilegeAlert, Spinner } from "../../components/exports";
import { UserAccessTypes } from "../../components/shared/PrivilegeAlert";

export default function DeleteUser() {
    let { id } = useParams();
    const navigate = useNavigate();

    const [user, setUser] = useState<UserDto | null>(null);
    const [requestInProgress, setRequestInProgress] = useState(false);

    useEffect(() => {
        const userId = parseInt(id);
        AccountService.getUserById(userId).then((r) => {
            setUser(r);
        });
    }, []);

    if (!user) {
        return <Spinner />;
    }

    const handleDeleteUser = () => {
        setRequestInProgress(true);
        AccountService.removeUser(parseInt(id))
            .then((r) => {
                navigateToUsers();
            })
            .catch((e) => {
                setRequestInProgress(false);
            });
    };

    const navigateToUsers = () => {
        navigate("/users");
    };

    return (
        <Container maxWidth="xs">
            <PageHeader title="حذف کاربر" />

            <PrivilegeAlert access={UserAccessTypes.ManageUsers} />

            <Paper sx={{ p: 2 }}>
                <Stack spacing={2}>
                    <Typography>
                        آیا مایل به حذف کاربر با شماره {user.mobileNumber} و نام{" "}
                        {user.displayName} میباشید؟
                    </Typography>

                    <Alert severity="error">
                        در صورت حذف این کاربر تمامی پروژه های مشاهده شده، فرایند
                        های فروش و فعالیت های ثبت شده توسط این شخص از دسترس خارج
                        شده و قابل بازگشت نخواهند بود
                    </Alert>

                    <Stack direction="row" justifyContent="space-between">
                        <Button
                            variant="contained"
                            disabled={requestInProgress}
                            color="warning"
                            onClick={handleDeleteUser}
                        >
                            بله از حذف کاربر اطمینان دارم
                        </Button>

                        <Button
                            variant="contained"
                            color="info"
                            onClick={navigateToUsers}
                        >
                            بازگشت
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Container>
    );
}
